import * as React from 'react';
import { connect } from 'react-redux';
import { IProductInfo, IState } from '../CustomTypes';
import { svgFinnLogo, svgVgLogo } from '../icons';
import './FooterSameLoginAsOthers.scss';

export interface IStateProps {
  productInfo?: IProductInfo;
}

export class FooterSameLoginAsOthers extends React.Component<IStateProps, {}> {
  public render() {
    const { children } = this.props;
    const { owningClient } = this.props.productInfo;
    return (
      <div className="footerSameLoginAsOthers container">
        {children ? <div className="row">{children}</div> : null}

        <div className="arrow">
          <span className="arrow-up" />
        </div>
        <div className="content">
          <div className="row">
            <div className="col-xs-12 teaserText">
              Vi har samme innlogging som på
            </div>
          </div>
          <div className="row logos">
            <span className="logo">{svgFinnLogo(28, 100)}</span>
            <span className="logo">{svgVgLogo(24, 100)}</span>
            {owningClient !== 'AP' && (
              <span className="icon-ap logo fontlogo" />
            )}
            {owningClient !== 'BTI' && (
              <span className="icon-bti logo fontlogo" />
            )}
            {owningClient !== 'SA' && (
              <span className="icon-sa logo fontlogo" />
            )}
          </div>
          <div className="row readMore">
            <div className="row">
              <p style={{ fontSize: '.8rem' }}>
                <a href="https://info.privacy.schibsted.com/no/S010">
                  <span className="glyphicon glyphicon-info-sign" /> Hva er en
                  Schibsted-konto?
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect<IStateProps, void, {}>(
  (state: IState) =>
    ({
      productInfo: state.productInfo
    } as IStateProps)
)(FooterSameLoginAsOthers);



// WEBPACK FOOTER //
// ./src/layout-components/FooterSameLoginAsOthers.tsx